(function () {
  'use strict';
  function renderDetails(root, title, contents, note) {
    root.querySelector('[data-ml-bundle-heading]').textContent = title;
    root.querySelector('[data-ml-bundle-contents]').textContent = contents;
    var footnote = root.querySelector('[data-ml-bundle-note]');
    footnote.textContent = note || '';
    footnote.hidden = !note;
    root.querySelector('[data-ml-bundle-details]').hidden = !contents;
  }
  function initRequest(root) {
    if (root.dataset.mlInitialized) return;
    root.dataset.mlInitialized = 'true';
    var form = root.closest('form');
    var select = root.querySelector('[data-ml-bundle-select]');
    var type = form.querySelector('[name="contact[Product Type]"]');
    var priceField = root.querySelector('[data-ml-bundle-price-field]');
    var contentsField = root.querySelector('[data-ml-bundle-contents-field]');
    function update() {
      var option = select.selectedOptions[0];
      var valid = option && option.dataset.contents && option.dataset.price;
      renderDetails(root, valid ? option.dataset.title : '', valid ? option.dataset.contents : '', valid ? option.dataset.note : '');
      priceField.value = valid ? option.dataset.price : '';
      contentsField.value = valid ? option.dataset.contents + (option.dataset.note ? '\n' + option.dataset.note : '') : '';
      priceField.disabled = contentsField.disabled = !valid;
      if (valid) {
        var matching = Array.from(type.options).find(function (item) { return item.dataset.mlBundleType === option.dataset.group; });
        if (matching) type.value = matching.value;
      }
      select.required = !!type.selectedOptions[0].dataset.mlBundleType;
      select.setCustomValidity(select.value && !valid ? 'Please choose a listed gift bundle package.' : '');
    }
    select.addEventListener('change', update);
    type.addEventListener('change', function () {
      var group = type.selectedOptions[0].dataset.mlBundleType;
      Array.from(select.options).forEach(function (option) {
        option.disabled = !!(group && group !== 'all' && option.dataset.group && option.dataset.group !== group);
      });
      if (!group || (select.selectedOptions[0].dataset.group && select.selectedOptions[0].disabled)) select.value = '';
      update();
    });
    var params = new URLSearchParams(window.location.search);
    var preselected = Array.from(select.options).find(function (option) {
      return option.dataset.group === params.get('bundle') && option.dataset.package === params.get('package');
    });
    if (preselected) select.value = preselected.value;
    update();
    form.addEventListener('submit', function (event) {
      update();
      if (!select.checkValidity()) { event.preventDefault(); select.reportValidity(); }
    });
  }
  function initProduct(root) {
    if (root.dataset.mlInitialized) return;
    root.dataset.mlInitialized = 'true';
    var section = root.closest('.ml-product-template');
    var form = root.closest('form');
    var button = form.querySelector('[name="add"]');
    var group;
    try { group = JSON.parse(root.querySelector('[data-ml-bundle-group]').textContent); } catch (error) { group = null; }
    function update() {
      var input = form.querySelector('[data-ml-variant-id], [data-ml-variant-select], [name="id"]');
      var variantId = input ? String(input.value) : '';
      var selected = group && Array.isArray(group.packages) && group.packages.find(function (item) { return item && String(item.variantId) === variantId; });
      var valid = selected && typeof selected.price === 'number' && selected.price > 0 && typeof selected.contents === 'string' && selected.contents.length > 0 && typeof selected.name === 'string' && selected.name.length > 0;
      var error = root.querySelector('[data-ml-bundle-error]');
      if (!valid) {
        renderDetails(root, 'Package contents', '', '');
        error.hidden = false;
        if (button) button.disabled = true;
        return false;
      }
      var priceElement = section.querySelector('[data-ml-product-price]');
      var picker = form.querySelector('[data-ml-variants]');
      var variant;
      if (picker) {
        try { variant = JSON.parse(picker.textContent).find(function (item) { return String(item.id) === variantId; }); } catch (parseError) { variant = null; }
      } else {
        var legacyOption = form.querySelector('[data-ml-variant-select]');
        variant = legacyOption && { priceCents: Number(legacyOption.selectedOptions[0].dataset.priceCents), available: legacyOption.selectedOptions[0].dataset.available === 'true' };
      }
      if (!variant || variant.priceCents !== selected.price * 100) {
        renderDetails(root, selected.name, selected.contents, '');
        error.hidden = false;
        if (button) button.disabled = true;
        return false;
      }
      error.hidden = true;
      var notes = Array.isArray(selected.notes) ? selected.notes.filter(function (note) { return typeof note === 'string'; }) : [];
      renderDetails(root, selected.name + ' – $' + selected.price, selected.contents, notes.filter(Boolean).join(' '));
      if (priceElement && variant.price) priceElement.textContent = variant.price;
      if (button) button.disabled = !variant.available;
      return true;
    }
    form.addEventListener('change', update);
    form.addEventListener('submit', function (event) { if (!update()) event.preventDefault(); });
    update();
  }
  function init() {
    document.querySelectorAll('[data-ml-bundle-request]').forEach(initRequest);
    document.querySelectorAll('[data-ml-bundle-product]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
